<template>

<div>

  <div style="background-color: #FCA94C;  z-index: 0" class="hero-wrapper">


    <div class="container d-flex justify-content-between align-items-center hero" >
      <img src="../../assets/images/sushiHub/bag.png"  alt="" style="margin-right: 2rem">
      <div v-if="store.Location" class="hero-text" style="width: 70vw;" >
        <p class="text-white montserrat-700" style="font-size: 30px">{{ store.Name  }}</p>
        <h4 class="text-white montserrat-700 " v-if="store.StoreTitle">{{ store.StoreTitle  }}</h4>
        <p class="text-white montserrat-700 mb-2">
          {{ store.Location.Address  }}
        </p>
        <p class="text-white montserrat-700 mb-2"> {{
            (store.Location.Suburb || "") +
            " " +
            (store.Location.State || "") +
            " " +
            (store.Location.Postcode || "")
          }}</p>
        <p class="text-white montserrat-700 mb-2" v-if="store.OfficePhone">{{ store.OfficePhone }}</p>
        <p class="text-white montserrat-700 mb-2">{{getOperatingHours(store).openTime}} to {{getOperatingHours(store).closeTime}}</p>
      </div>
    </div>

  </div>
</div>
</template>

<style>
  .hero-wrapper {
    height: 60vh;
  }

  .hero {
    padding-left: 30rem;
    padding-right: 20rem;
    transform: translateY(5%);
  }

  .hero img {
    width: 65vh;
    margin-left: 2rem;
  }

  .hero-text {
    margin-right: 8rem;
  }
  @media (max-width: 992px) {
    .hero-wrapper{
      height: 50vh;
    }

    .hero {
      padding: 10rem;
      padding-right: 10rem;
      transform: translateY(5%);
    }

    .hero img{
      width: 30vh;
    }

    .hero-text {
      margin-left: 2rem;
      margin-right : 0
    }
  }

</style>

<script>
import {getCurrentDate, operatingHours} from "@/api/helpers/datetimeHelper";

export default {
  name: "sushiStoreBanner",
  props :  ['store'],
  methods: {

    getOperatingHours(storedoc) {
      var now = getCurrentDate(storedoc.TimezoneCity);
      return operatingHours(storedoc.BlackoutDates, now, storedoc.OperatingHours, true);
    },
  }
}
</script>

<style scoped>

</style>
